export default {
  brand: {
    fileShare: 'Compartir Archivos'
  },
  common: {
    loading: 'Cargando...',
    confirm: 'Confirmar',
    cancel: 'Cancelar',
    download: 'Descargar',
    downloadAll: 'Descargar todo',
    downloadSelected: 'Descargar seleccionados',
    selectAll: 'Seleccionar todo',
    deselectAll: 'Deseleccionar',
    rootDirectory: 'Directorio raíz',
    createTime: 'Creado',
    expireTime: 'Expira',
    totalSize: 'Tamaño total',
    noFiles: 'No hay archivos'
  },
  share: {
    expired: 'Los archivos compartidos han expirado',
    invalidLink: 'Enlace de compartir inválido',
    needVerifyCode: 'Por favor ingrese el código de extracción',
    verifyCodeLabel: 'Código',
    verifyCodePlaceholder: 'Ingrese código de extracción',
    extractFiles: 'Extraer archivos',
    extractionCodeError: 'Código de extracción incorrecto',
    uuidRequestFailed: 'Solicitud de descarga fallida',
    selectFilesFirst: 'Por favor seleccione archivos primero',
    unknownError: 'Error desconocido'
  },
  error: {
    networkError: 'Error de red',
    connectionFailed: 'No se puede conectar al dispositivo de compartir. El dispositivo puede estar apagado, en suspensión o la región de servicio puede haber cambiado. Por favor contacte al compartidor.',
    outdatedLink: 'No se puede conectar al dispositivo de compartir. Es posible que se haya utilizado un enlace de compartir obsoleto. Por favor pida al compartidor que actualice el sistema a v2.0.10 o superior, la APP a v2.1.5 o superior y vuelva a copiar el enlace de compartir.',
    registryError: 'Error al obtener la configuración de penetración de red pública. No se puede conectar al servicio de Registro.',
    missingRegion: 'Al enlace de compartir le falta información de la región de servicio. Por favor pida al compartidor que actualice el sistema a v2.0.10 o superior, la APP a v2.1.5 o superior y vuelva a copiar el enlace de compartir.'
  }
}
